// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbsContainer":"mxmA_6","breadCrumbs":"GqQ26z","item":"NfuTnz","itemInactive":"zXRMFb","separator":"rV7Q_y"};